<template>
<div>
    <div :class="['effectInput',active?'activeDiv':'']"  @click="inputClick" v-if="!isLabel">
        <span class="effectSpan">{{label}}</span>
        <Input ref="inputVal" maxlength="150" v-model="effectValue" :placeholder="placeholder" :type="type ? type : 'text'" :readonly="readonly" :disabled="disabled" v-show="active" @on-blur="blurEvent($event)" ></Input>
    </div>
    <Input v-if="isLabel" maxlength="150" ref="inputVal" v-model="effectValue" :placeholder="placeholder" ></Input>
</div>
    
</template>
<script>
    export default {
        props: ['label','value','readonly','disabled','isLabel','type','placeholder'],
        data () {
            return {
                effectValue: '',
                openModel:{
                    check1:'',
                    check2:''
                },
                active:false
            }
        },
        watch: {
            value(val){
				this.effectValue = val
                if(val){
                    this.active = true
                }else{
                    this.active = false
                }
            },
            effectValue (val) {
                this.$emit('input',val)
            }
        },
        methods: {
            ok () {
                this.$Message.info('Clicked ok');
            },
            cancel () {
                this.$emit('closeDialog',false)
                // this.$Message.info('Clicked cancel');
            },
            inputClick () {
                this.active = true
                this.$nextTick(function () {
                    //DOM 更新了
                    this.$refs.inputVal.focus();
                })
            },
            blurEvent () {
                if(!this.value){
                    this.active = false
                }
            }
        },
        created() {
            this.effectValue = this.value
            if(this.effectValue || this.effectValue === 0){
                this.active = true
            }
        }
    }
</script>
<style lang="less" >

</style>
